export default __webpack_public_path__ + "static/media/mantenimiento.5590a3c8.png";